import { getIdFromUrn } from '@widesk-core/tools/identifier';
import { isUrn }       from '@widesk-core/tools/identifier';
import appStore        from '@/stores/appStore';

export function formatProtobufTimestamp(timestamp: { seconds: number; nanos?: number }): string {
	const date = new Date(timestamp.seconds * 1000);
	return date.toISOString().replace('Z', '+00:00');
}

/**
 * Ce qu'un évènement Mercure apprend sur "la dernière modification" affichée par `SaveStatusBanner`,
 * quel que soit son `kind` : créer, modifier ou supprimer une forme, comme changer la configuration
 * d'une carte, sont autant de modifications du projet du point de vue de l'utilisateur.
 *
 * L'identité de l'auteur ne sert QU'À décider si on affiche un nom, jamais à ignorer l'évènement :
 * un même compte ouvert sur deux écrans est un cas courant, et c'est justement celui où le message
 * doit bouger tout seul. `byUserUrn` reste donc vide pour nos propres écritures — on n'écrit pas "par
 * soi-même" — comme pour un auteur absent du message, qu'on préfère taire plutôt qu'inventer.
 *
 * L'URN est conservée telle quelle, et pas seulement l'id qu'elle contient : c'est elle qui permet de
 * retrouver le nom d'un auteur qui n'est pas connecté (voir `authorNameStore`).
 */
export function readModification(proto: any): { at: Date; byUserUrn?: Urn } {
	const by: string | undefined = proto.updatedBy || proto.createdBy;
	const byUserUrn = by && isUrn(by) ? by as Urn : undefined;
	const isSelf = !byUserUrn || String(getIdFromUrn(byUserUrn)) === String(appStore.user.id);

	// L'horodatage du serveur plutôt que l'heure de réception, quand il est exploitable : `seconds`
	// peut remonter en `Long` selon la configuration de protobufjs, auquel cas le calcul de
	// `formatProtobufTimestamp` donne une date invalide — on retombe alors sur "maintenant", à
	// quelques centaines de millisecondes près de toute façon.
	const at = proto.updatedAt ? new Date(formatProtobufTimestamp(proto.updatedAt)) : new Date();

	return {
		at: isNaN(at.getTime()) ? new Date() : at,
		byUserUrn: isSelf ? undefined : byUserUrn,
	};
}
